import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { CreateProjectBlock } from "../../components/ProjectBlocks/CreateProjectBlock/CreateProjectBlock";
import { Layout } from "../../components/Layout/Layout";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useAppDispatch } from "../../store";
import { fetchCustomers } from "../../store/slices/customers";
import { fetchCreateProject } from "../../store/slices/projects";
import { ProjectForm } from "../../model/projects";
import { SortingTypes } from "../../helpers/SortingTypes";

export const CreateProjectPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formik = useFormik<ProjectForm>({
    initialValues: {
      name: "",
      customer_id: null,
      status: null,
      comments: "",
      description: "",
      responsible_user_id: null,
      legal_entity_id: null,
      project_format_id: null,
      start_at: undefined,
      planned_end_at: undefined,
    },
    onSubmit: () => { },
  });

  useEffect(() => {
      dispatch(fetchCustomers({ params: { filters: { limit: "100000", offset: "0", sort_direction: SortingTypes.DESC } } }));
    }, [dispatch]);

  return (
    <Layout>
      <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
        <Text color="gray.500" cursor="pointer" onClick={() => navigate("/projects")} display="flex" alignItems="center" gap="8px">
          <ArrowBackIcon />
          К списку проектов
        </Text>
        <Flex flexDirection="column" gap="4px">
          <Text fontSize={24} fontWeight={500}>Создание проекта</Text>
          <Text color="gray.500">Заполните информацию о новом проекте</Text>
        </Flex>
        <CreateProjectBlock formik={formik} />
        <Flex gap="16px" justifyContent="flex-end">
          <Button onClick={() => navigate("/projects")}>Отмена</Button>
          <Button
            bg="#2563eb"
            color="white"
            _hover={{ bg: "#2563eb" }}
            _active={{ bg: "#2563eb" }}
            onClick={() => {
              dispatch(fetchCreateProject(formik.values))
                .then((res: any) => {
                  if (res.payload.id) {
                    navigate(`/projects/${res.payload.id}`)
                  }
                })
            }}
            isDisabled={
              formik.values.name === "" ||
              formik.values.customer_id === null ||
              formik.values.responsible_user_id === null ||
              formik.values.status === null ||
              formik.values.legal_entity_id === null ||
              formik.values.project_format_id === null
            }
          >Создать проект</Button>
        </Flex>
      </Flex>
    </Layout>
  );
};
